<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        
      </div>
      <div class="beanstalk_1">
        <div class="hadoop">
          <ul>
            <li class="icon_a actived"><a href="#/hadoop/beanstalk">Beanstalk企业研发管理平台</a></li>
            <li class="icon_b"><a href="#/hadoop/bigdataPlatform">大数据测试平台</a></li>
            <li class="icon_c"><a href="#/hadoop/agileManagement">敏捷管理咨询</a></li>
            <li class="icon_d"><a href="#/hadoop/qualityManagement">质量管理咨询</a></li>
          </ul>
        </div>
        <div class="share">
          <div style="height:45px;width:415px;margin:0 auto;"><h2>Beanstalk企业研发管理平台</h2></div>
          <span></span>
        </div>
        <div class="view-tip change">
          <p class="title">行业挑战</p>
          <div class="detail">
            <p style="margin-top:-10px;margin-bottom:5px">随着IT开发项目规模的不断扩大，开发过程的效率和质量保障都面临严峻的挑战，比如：</p>
            <ul>
              <li>传统模式节奏慢，难以适应市场变化；</li>
              <li>引入大量工具，用户使用不方便，工具间功能集成不完善，形成信息孤岛；</li>
              <li>研发流程过于冗余，团队额外负担大，开发过程对管理层不透明。</li>
            </ul>
          </div>
        </div>
        <div class="view-tip summarize">
          <p class="title">产品概述</p>
           <div class="detail">
            <p>Beanstalk企业研发管理平台是一站式研发管理平台，它摒弃种类繁多的系统带来的信息割裂，通过端到端全链路信息化管理，使数据更加透明，团队协作更紧密，组织更高效。</p>
           </div>
        </div>
      </div>
      <div class="beanstalk_2">
        <div class="view-tip solution">
          <p class="title">解决方案</p>
           <div class="detail">
            <span>项目管理</span>
            <p>Beanstalk企业研发管理平台项目管理支持传统瀑布管理，支持风险及变更管理，满足CMMI要求。支持时下流行的敏捷开发的全生命周期管理，满足CMMI要求。支持时下流行的敏捷
               开发的全生命周期管理，包括团队级和组织级敏捷框架SAFe。</p>
           </div>
           <div class="detail">
            <span>测试管理</span>
            <p>Beanstalk企业研发管理平台测试管理是支持用例管理，测试计划以及缺陷管理等，满足TMMi要求。该模块可为测试团队提供API自动化测试和UI自动化测试能力，可以为敏捷开发团队
                和专业测试团队提供丰富的管理功能。</p>
           </div>
           <div class="detail">
            <span>CI/CD</span>
            <p>Beanstalk企业研发管理平台 CI/CD模块支持帮助团队快捷和低学习成本地使用完整的DevOps全流程工具链。支持集成Jenkins，Jira，Git/SVN，K8s等众多工具平台，让持续集成、
                持续交付、持续部署可视化。</p>
           </div>
           <div class="detail">
            <span>Wiki</span>
            <p>Beanstalk企业研发管理平台Wiki是立体的知识管理方案，支持文档协作、知识沉淀和团队知识学习，帮助团队向知识型组织迈进。</p>
           </div>
        </div>
      </div>
      <div class="beanstalk_3">
        <div class="view-tip platform">
          <p class="title">平台架构系统</p>
          <div style="margin-top:60px">
            <img style="width:1200px" src="../../../public/hadoopImg/platform.png" alt="">
          </div>
        </div>
        <div class="view-tip business">
          <p class="title">商业价值</p>
          <div class="detail" >
            <ul>
              <li>Beanstalk全流程、全场景的软件项目管理方案，适用于所有类型、所有规模的研发团队；</li>
              <li>打破部门墙，自然获取端到端的全局信息，提升透明度，并通过丰富的报表为组织优化提供支撑；</li>
              <li>支持对常见工具集成并支持二次开发，支持存量数据导入，并减少工具导入成本。</li>
            </ul>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>
<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'大数据及效能',
          detail:'Big data & efficiency',
          src: require("../../../public/hadoopImg/dashuju1.png")
        },
      ]
    }
  }
}
</script>


<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 32px;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: disc;
        margin-left: 18px;
        li{
          padding-bottom: 5px;
        }
      }
    }
  }

.beanstalk_1{
  height: 645px;
  position: relative;
  .summarize{
    margin-top: 60px;
  }
  .hadoop{
    position: absolute;
    width: 1200px;
    height: 150px;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top:-75px ;
    background: url(../../../public/hadoopImg/hadoop.png) center;
    ul{
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      li{height: 40px;line-height: 40px;}
      .icon_a{
        background: url("../../../public/hadoopImg/icon_a.png") no-repeat;
      }
      .actived,.icon_a:hover{
        background: url("../../../public/hadoopImg/icon_a1.png") no-repeat;
      }
      .icon_b{
        background: url("../../../public/hadoopImg/icon_b.png") no-repeat;
      }
      .icon_b:hover{
        background: url("../../../public/hadoopImg/icon_b1.png") no-repeat;
      }
      .icon_c{
        background: url("../../../public/hadoopImg/icon_c.png") no-repeat;
      }
      .icon_c:hover{
        background: url("../../../public/hadoopImg/icon_c1.png") no-repeat;
      }
      .actived a{color: #01619E;}
      .icon_d{
        background: url("../../../public/hadoopImg/icon_d.png") no-repeat;
      }
      .icon_d:hover{
        background: url("../../../public/hadoopImg/icon_d1.png") no-repeat;
      }
      li:hover{
        color: #01619E;
      }
    }
    a{
      color: #333;
      padding-left: 50px;
    }
    a:hover,a:active{
      color: #01619E;
    }
  }
}

.beanstalk_2{
  height: 637px;
  background: #F8F9FB;
  .solution{
    padding-top: 60px;
  }
}
.beanstalk_3{
  height: 1052px;
  .platform{
    padding-top: 60px;
    margin-bottom: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Hadoop/beanstalk.vue